// Third-party imports
import $ from 'jquery';

// Local imports
import {
    changeHandler,
    injectVariantIDCartButton,
    itemNotFoundHandler,
} from './page_handler.js';

export function userSelectionEventInitializer(global, args) {
    $('.js-variant-hook').on('change', () => {
        let userValues = buildUserSelectedValuesArray(global);
        injectVariantIDCartButton('');
        userSelectionHandler(args, userValues);
        // The following only applies to OGC re-designed pages.
        // we wrap this functionality inside an IF statement with an element
        // that only appears on the re-designed product page.
        let viewButton = $('#view_basket');
        if (viewButton.length) {
            $('.qtyChange-hook').hide();
            viewButton.addClass('button--removed');
            let add_button = $('#to_cart');
            add_button.removeClass('button--removed');
        }
    });
}

function buildUserSelectedValuesArray(global) {
    let valuesArray = [];
    let matches = global.document.querySelectorAll('.js-variant-hook');
    for (let el of matches) {
        if (el.checked) {
            valuesArray.push(el.value);
        }
    }
    return valuesArray;
}

export function userSelectionHandler(args, userValues) {
    for (let x = 0; x < args.variantsArray.length; x++) {
        if (userSelectedOneValueAndIsNumberOfVariants(args, userValues)) {
            if (userValueIsEqualToProductOption(args, userValues, x)) {
                changeHandler(args, x);
                break;
            }
        } else if (
            userSelectedTwoValuesAndIsNumberOfVariants(args, userValues)
        ) {
            if (
                twoUserValuesAreEqualToRespectiveProductOptions(
                    args,
                    userValues,
                    x
                )
            ) {
                changeHandler(args, x);
                break;
            } else if (x + 1 === args.variantsArray.length) {
                itemNotFoundHandler();
            }
        } else if (
            userSelectedThreeValuesAndIsNumberOfVariants(args, userValues)
        ) {
            if (
                threeUserValuesAreEqualToRespectiveProductOptions(
                    args,
                    userValues,
                    x
                )
            ) {
                changeHandler(args, x);
                break;
            } else if (x + 1 === args.variantsArray.length) {
                itemNotFoundHandler();
            }
        }
    }
}

function userSelectedOneValueAndIsNumberOfVariants(args, userValues) {
    let ret =
        userValues.length === 1 && userValues.length === args.numberOfVariants;
    return ret;
}

function userSelectedTwoValuesAndIsNumberOfVariants(args, userValues) {
    let ret =
        userValues.length === 2 && userValues.length === args.numberOfVariants;
    return ret;
}

function userSelectedThreeValuesAndIsNumberOfVariants(args, userValues) {
    let ret =
        userValues.length === 3 && userValues.length === args.numberOfVariants;
    return ret;
}

function userValueIsEqualToProductOption(args, userValues, index) {
    let ret =
        userValues[0].toString() ===
        args.variantsArray[index].option1.toString();
    return ret;
}

function twoUserValuesAreEqualToRespectiveProductOptions(
    args,
    userValues,
    index
) {
    let ret =
        userValues[0].toString() ===
            args.variantsArray[index].option1.toString() &&
        userValues[1].toString() ===
            args.variantsArray[index].option2.toString();
    return ret;
}

function threeUserValuesAreEqualToRespectiveProductOptions(
    args,
    userValues,
    index
) {
    let ret =
        userValues[0].toString() ===
            args.variantsArray[index].option1.toString() &&
        userValues[1].toString() ===
            args.variantsArray[index].option2.toString() &&
        userValues[2].toString() ===
            args.variantsArray[index].option3.toString();
    return ret;
}
